export const increamentScale = () => {
    return async (dispatch) => {
        await dispatch({type:"INCREAMENT_SCALE"});
    }
}

export const decreamentScale = () => {
    return async (dispatch) => {
        await dispatch({type:"DECREAMENT_SCALE"});
    }
}

export const cleartScale = () => {
    return async (dispatch) => {
        await dispatch({type:"CLEAR_SCALE"})
    }
}